import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import { scpClient } from '../constants/SiteVariables';

export default class Home extends React.Component {
  redirect = () => {
    window.location.href = scpClient();
  }

  render() {
    return (
     <section className="hero home is-fullheight">
      <Header {...this.props} />
      <div className="hero-body">
        <div className="container has-text-centered">
          <p>Looking for a better way to reach your goals?</p>
          <h1 className="title is-3">Get Started Today</h1>
          <div className="buttons is-centered">
            <Link to="/request" className="button is-rounded is-size-5 is-info is-outlined">Get Access Code</Link>

            <Link to="/access" className="button is-rounded is-size-5 is-info is-outlined">
              Enter Access Code
            </Link>

            <span className="button is-rounded is-size-5 is-info is-outlined" onClick={this.redirect}>Returning Members</span>
          </div>
        </div>
      </div>
    </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js